// The code in this file will load on every page of your site

$w.onReady(function () {
	// Write your code here
// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	// To make this Code work in all of your site pages,
	// Move these lines into the the 'Site Code' panel on the left


});
});